import useSWR from "swr";
import { adminUsersService } from "../../api_client";
import type { PaginationMeta } from "../../../api";

// The backend returns prisma-extension-pagination's meta, whose count field is
// `totalCount`. The previous `meta.total` was masked by an `as unknown as` cast
// and silently rendered 0 in all three stat cards.
interface AdminUsersResult {
  meta?: PaginationMeta;
}

const countOf = (res: { data: unknown }) =>
  (res.data as AdminUsersResult).meta?.totalCount ?? 0;

export function useAdminUserStats() {
  const { data } = useSWR("admin-user-stats", async () => {
    const [all, active, admins] = await Promise.all([
      adminUsersService.adminListUsers({ page: 1, pageSize: 1 }),
      adminUsersService.adminListUsers({ page: 1, pageSize: 1, isActive: true }),
      adminUsersService.adminListUsers({ page: 1, pageSize: 1, role: "admin" as const }),
    ]);
    return {
      total: countOf(all),
      active: countOf(active),
      admins: countOf(admins),
    };
  }, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  return {
    total: data?.total ?? 0,
    active: data?.active ?? 0,
    admins: data?.admins ?? 0,
  };
}
